import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 400px;
  background-color: var(--t-brand-bg-color);
  border-radius: var(--t-cards-border-radius, 14px);
  overflow: hidden;
  cursor: pointer;
  transition: transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out;

  &:hover {
    transform: translateY(-4px);
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.1);
  }

  &:focus-visible {
    outline: 2px solid var(--t-interactive-accent-color);
    outline-offset: 2px;
  }
`;

export const MediaContainer = styled.div`
  position: relative;
  width: 100%;
  overflow: hidden;
  aspect-ratio: 16 / 9;
`;

export const IconOverlay = styled.div`
  position: absolute;
  bottom: 16px;
  right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  background-color: rgba(255, 255, 255, 0.9);
  border-radius: 50%;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  z-index: 10;

  @media (min-width: 768px) {
    width: 56px;
    height: 56px;
    bottom: 24px;
    right: 24px;
  }
`;

export const ContentContainer = styled.div`
  padding: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;

  @media (min-width: 768px) {
    padding: 24px;
    gap: 12px;
  }

  @media (min-width: 992px) {
    padding: 32px;
    gap: 16px;
  }
`;

export const TextArrowWrapper = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 16px;
`;

export const CtaArrow = styled.div`
  display: flex;
  align-items: center;
  flex-shrink: 0;
  color: var(--t-interactive-accent-color);

  svg {
    width: 24px;
    height: 24px;
  }
`;
